import React, { useEffect, useMemo, useState } from "react";
import { Datagrid } from "@abb/abb-common-ux-react";
import filterTableData from "./evci-eds-tabledata.json";


function EvciTableData() {
  const [data, setData] = useState([]);

  // Define the columns we want to show: timestamp, code, description
  const columns = useMemo(() => [
    {
      fieldKey: "timestamp",
      title: "TIMESTAMP",
      width: '25%',
    },
    {
      fieldKey: "code",
      title: "CODE",
      width: '15%',
    },
    {
      fieldKey: "description",
      title: "DESCRIPTION",
      width: '60%',
    }
  ], []);

  const initialData = useMemo(() => {
    return filterTableData.tableData.map((entry) => ({
      fields: {
        timestamp: entry.timestamp || "",
        code: entry.code || "",
        description: entry.description || ""
      }
    }));
  }, []);

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  return (
    <>
      {filterTableData.title?.isEnabled && (
        <h3>{filterTableData.title.value}</h3>
      )}
      <div style={{ width: '100%', padding: '0 20px 20px 20px' }}>
        <div style={{ maxHeight: '200px' }}>
          <Datagrid
            className="table-style-alarm-noti"
            columns={columns}
            data={data}
            rowHeight="small"
            enableSorting={true}
            style={{
              fontSize: '12px',
              width: '100%'
            }}
          />
        </div>
      </div>
    </>
  );
}

export default EvciTableData;
